import { Box } from "@mui/material";
import { ChartData, ChartOptions } from "chart.js";
import times from "lodash/times";
import { chartUtil } from "../../../common";

type BoZoneSparklineProps = {
  points: chartUtil.ChartPoints;
  color: string;
};

export const BoZoneSparkline = (props: BoZoneSparklineProps) => {
  const scored = chartUtil.realPoints(props.points);
  // With no scores at all, fall back to the full range so only Xs render.
  const min = scored.length ? Math.min(...scored) : chartUtil.scoreMin;
  const max = scored.length ? Math.max(...scored) : chartUtil.scoreMax;
  const padding = Math.max((max - min) * 0.25, 0.1);

  const data: ChartData<"line", chartUtil.ChartPoints, string> = {
    labels: times(props.points.length, String),
    datasets: [
      {
        ...chartUtil.lineDefaults,
        data: props.points,
        borderColor: props.color,
        segment: chartUtil.gapSegment(props.color),
        borderWidth: 3,
        pointHitRadius: 0,
        pointBackgroundColor: props.color,
        pointBorderWidth: 0,
        pointRadius: (ctx) => (ctx.raw === null ? 0 : 3),
      },
    ],
  };

  const options: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    layout: {
      padding: {
        top: 6,
        right: 8,
        bottom: 14,
        left: 8,
      },
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
        min: min - padding,
        max: max + padding,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  const canvasRef = chartUtil.useLineChart(data, options, [
    ...chartUtil.lineGlowPlugins,
    chartUtil.missingScoreMarkers,
  ]);

  return (
    <Box width="5.5rem" height="3rem" flexShrink={0}>
      <canvas ref={canvasRef} />
    </Box>
  );
};
